import {FilteringGridWithBulkOperations} from './filtering_grid_with_bulk_operations.js';

export const ClubMembersView = Backbone.View.extend({
  el: '#club-members',
  initialize: function() {
    this.editable = this.options.editable;
    this.data = this.options.data.map(this.cleanMemberData)
    this.tags = _.uniq(this.options.data.reduce(this.selectTags, []));
    this.clubId = this.options.clubId;
    this.currentMemberId = this.options.baseCurrentMember && this.options.baseCurrentMember.id;
    this.settings = this.options.settings || { }
    this.savedSettings = this.settings.saved || { }

    this.initTagInputBoxes();
    this.initGrid();

    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
    this.resizeGrid();
    this.resizeGrid();

    $(window).resize(_.debounce(() => {
      this.resizeGrid();
    }, 100));
  },
  events: {
    // filtering
    'keyup .filter_by_any': 'filterTextInputChanged',
    'change .filter_by_permission': 'filtersChanged',
    'change .filter_by_tag': 'filtersChanged',
    // bulk operations
    'click .bulk-op-disabled': 'showDisabledMessage',
    'click .show_bulk_op': 'showBulkOp',
    'click .batch_delete': 'batchDelete',
    'click .batch_make_active': 'batchMakeActive',
    'click .batch_make_inactive': 'batchMakeInactive',
    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
    'click .batch_send_message': 'onBatchMessageClick',
    // misc
    'click .grid_height_increase': 'increaseGridHeight',
    'click .grid_height_decrease': 'decreaseGridHeight',
    // row-level actions
    'change .grid_checkbox': 'onCheckboxChange',
    'click .approve_member': 'onApproveMember'
  },
  initGrid: function() {
    const self = this
    const data = this.data
    const formatters = FilteringGridWithBulkOperations.formatters;

    const disableableCheckbox = (value, message) => {
      const dataDisabled = message ? `data-disabled="${message}"` : ''
      const disabledClass = message ? 'bulk-op-disabled' : ''
      return `<input type="checkbox" ${value && 'checked'} ${dataDisabled} class="grid_checkbox ${disabledClass}">`
    }
    const disabledIfAdmin = (action) => (row, cell, value, col, item) => {
      const message = item.admin && `You cannot ${action} for admins.`
      return disableableCheckbox(value, message)
    }
    const disabledIfSelfOrAdmin = (action) => (row, cell, value, col, item) => {
      const adminMessage = item.admin && `You cannot ${action} for admins.`
      const selfMessage = item.id === this.currentMemberId && `You cannot ${action} for yourself.`
      return disableableCheckbox(value, adminMessage || selfMessage)
    }
    const requiresAdminPriv = (action) => (row, cell, value) => {
      const message = !self.isClubAdmin() && `You must be an admin to ${action}.`
      return disableableCheckbox(value, message)
    }
    const blankUnlessApprovedMeta = (formatter) => {
      return (row, cell, value, col, item) => {
        return item.approved_at ? formatter(row, cell, value, col, item) : ''
      }
    }
    const approveUnlessApprovedMeta = (formatter) => {
      return (row, cell, value, col, item) => {
        return item.approved_at ? formatter(row, cell, value, col, item) : '<a href="#" class="approve_member">Approve</a>'
      }
    }

    // column definitions
    const columns = [
      {id:"first_name", name:'First name', field:"first_name", sortable:true, editor:Slick.Editors.Text},
      {id:"last_name", name:'Last name', field:"last_name", sortable:true, editor:Slick.Editors.Text},
      {id:"display_name", name:'Display name', field:"display_name", sortable:true},
      {id:"email", name:'Email', field:"email", sortable:true, editor:Slick.Editors.Text},
      {id:"tags", name:'Tags', field:"tags", sortable:true, formatter: formatters.tags},
      {id:"admin", name:'Admin', field:"admin", sortable:true, formatter: blankUnlessApprovedMeta(requiresAdminPriv("set admin privileges"))},
      {id:"manages_routes", name:'Route manager', field:"manages_routes", sortable:true, formatter: blankUnlessApprovedMeta(disabledIfAdmin("set route manager permission"))},
      {id:"manages_billing", name:'Billing manager', field:"manages_billing", sortable:true, formatter: blankUnlessApprovedMeta(disabledIfAdmin("set billing manager permission"))},
      {id:"manages_members", name:'Member manager', field:"manages_members", sortable:true, formatter: blankUnlessApprovedMeta(disabledIfSelfOrAdmin("set member manager permission"))},
      {id:"active", name:'Active', field:"active", sortable:true, formatter: approveUnlessApprovedMeta(disabledIfSelfOrAdmin("set active status"))},
      {id:"message", name: '', field:"message", formatter: this.messageFormatter, width: 20}
    ];

    const columnWidths = Object.assign({
      message: 20
    }, this.savedSettings.columnWidths || {})
    columns.forEach(column => column.width = columnWidths[column.id])

    const anyFilter = this.$('.filter_by_any')
    const permissionFilter = this.$('.filter_by_permission')
    const tagFilter = this.$('.filter_by_tag')
    const filterAccessors = new Map(Object.entries({
      any: anyFilter.val.bind(anyFilter),
      tag_names: tagFilter.select2.bind(tagFilter, "val"),
      permission: permissionFilter.val.bind(permissionFilter)
    }))

    // since approve links show up in the active bool column, need to factor that in while sorting
    let approvedSortFn = function (a, b) {
      return !a.approved_at === !b.approved_at ? 0 : (!a.approved_at ? 1 : -1)
    }

    this.grid = new FilteringGridWithBulkOperations(data, {
      target: '#members_table',
      columns: columns,
      editable: true,
      updatePath: (id) => `/clubs/${this.clubId}/update_member_field.json?club_member_id=${id}`,
      updateParam: 'club_member',
      viewPath: function(item) { return '/users/'+item.user_id;},
      ignoreCaseOnSort: ['first_name', 'last_name', 'display_name', 'email'],
      filterAccessors: filterAccessors,
      settingsOpts: this.settings.opts,
      stickySortFn: approvedSortFn
    })

    this.grid.sortingFn('tags', (a, b) => {
      const x = (a.tag_names || []).join().toUpperCase(), y = (b.tag_names || []).join().toUpperCase();
      return (x==y ? 0 : (x > y ? 1 : -1));
    })

    this.grid.enableFiltering([
      {field: 'any', type: 'anyString', extra: ['first_name', 'last_name', 'display_name', 'email']},
      {field: 'first_name', type: 'string'},
      {field: 'last_name', type: 'string'},
      {field: 'display_name', type: 'string'},
      {field: 'tag_names', type: 'arraySubset'},
      {field: 'email', type: 'string'},
      {field: 'permission', type: 'function', extra: this.filterByPermissionTest}
    ]);

    this.grid.enableBulkOperations({
      bulkDeletePath: `/clubs/${this.clubId}/batch_destroy_members.json`,
      bulkUpdateAttributePath: `/clubs/${this.clubId}/batch_set_members_attr.json`,
      idsParam: 'club_member_ids'
    });

    if (this.savedSettings.sortCol) {
      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc)
    } else {
      this.grid.setSort("email", true)
    }

    this.grid.slickGrid.onSelectedRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    this.grid.dataView.onRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    self.updateBulkOpVisibility()

    this.initBatchMessageModal()
  },

  messageFormatter: (row,cell,value,col,item) => (
    `<a href="/users/${rwgps.config.currentUser.id}/conversations/new?id=${item.user_id}" data-toggle="modal" data-target="#sendMessageModal">
      <i class="icon-envelope-alt"></i>
    </a>`
  ),

  isClubAdmin: function() {
    if (rwgps.config.currentUser.account_level == 11) {
      // Site admins can always act as club admins
      return true
    } else if (!this.currentMemberId) {
      // If the current user is not a member of the club, then they are
      // definitely not an admin
      return false
    } else {
      // If we've initialized the grid, use its data, otherwise use the data we
      // were passed by rails
      const member = this.grid
        ? this.grid.dataView.getItemById(this.currentMemberId)
        : this.data.find(item => item.id === this.currentMemberId)

      return (member && member.admin)
    }
  },

  /*
   * filtering
   */

  toggleFilters: function() {
    if (this.$('.toggle_filters .plus').is(':visible')) {
      this.showFilters()
    } else {
      this.hideFilters()
    }
  },

  showFilters: function() {
    this.$('.toggle_filters').find('.plus').hide().end().find('.minus').show();
    this.$('.filters').show();
  },

  hideFilters: function() {
    this.$('.toggle_filters').find('.plus').show().end().find('.minus').hide();
    this.$('.filters').hide();
  },

  filterTextInputChanged: function(e) {
    // clear on escape
    if(e.which == 27) e.currentTarget.value = '';
    this.filtersChanged()
  },

  filtersChanged: function() {
    if (this.grid) { this.grid.filterInputsChanged() }
  },

  filterByPermissionTest: (item, value) => {
    switch (value) {
      case 'admin':
      case 'manages_routes':
      case 'manages_billing':
      case 'manages_members':
        return item[value]
      case 'non_managers':
        return ! (item.manages_routes || item.manages_billing || item.manages_members)
      default:
        return true
    }
  },

  /*
   * editing
   */
  onCheckboxChange: function(e) {
    const {row, cell} = this.grid.slickGrid.getCellFromEvent(e)
    const {field} = this.grid.slickGrid.getColumns()[cell]
    const dataItem = this.grid.slickGrid.getDataItem(row)
    const {id: club_member_id} = dataItem
    const boolValue = e.currentTarget.checked
    const value = boolValue ? 1 : 0
    const removingOwnAdmin = field === "admin" && club_member_id === this.currentMemberId && !boolValue

    const updateValue = () => {
      // Set set the value immediately, and update or revert it once
      // we hear back from the server
      const oldValue = dataItem[field]
      dataItem[field] = boolValue
      this.grid.dataView.updateItem(dataItem.id, dataItem)

      this.grid.remoteRequest({
        url: `/clubs/${this.clubId}/update_member_field.json`,
        params: { club_member_id, field, value },
        done: (dataView, data) => {
          const memberData = this.cleanMemberData(data.club_member)
          dataView.updateItem(dataItem.id, memberData)

          // Removing one's own admin privs changes the disabled state of
          // checkboxes outside our own row, so rerender the whole grid
          if (removingOwnAdmin) { this.grid.slickGrid.invalidate() }
        },
        fail: () => {
          dataItem[field] = oldValue
          this.grid.dataView.updateItem(dataItem.id, dataItem)
          this.grid.slickGrid.invalidate()

        }
      })
    }

    if (removingOwnAdmin) {
      // Reset the checkbox to checked so it's not in the wrong state if the user cancels
      e.currentTarget.checked = true
      customConfirm('Are you sure? By unchecking this option, you will no longer have the ability to assign admin status to organization members.', updateValue)
    } else {
      updateValue()
    }
  },

  onApproveMember: function(e) {
    // TODO: This should use FilteringGridWithBulkOperations.remoteRequest to take advantage of error handling
    const {row} = this.grid.slickGrid.getCellFromEvent(e)
    const dataItem = this.grid.slickGrid.getDataItem(row)
    const {id: club_member_id} = dataItem

    $.post(`/clubs/${this.clubId}/approve_member.json`, {
      club_member_id
    }).done(res => {
      dataItem.approved_at = res.club_member.approved_at
      this.grid.dataView.updateItem(dataItem.id, dataItem)
    })
    return false
  },

  /*
   * bulk operations
   */
  updateBulkOpVisibility: function() {
    const grid = this.grid.slickGrid
    const data = grid.getData()
    const items = grid.getSelectedRows().map(i => data.getItem(i))

    const itemsEmpty = items.length == 0
    const adminsSelected = items.some(item => item.admin)
    const notAdmin = !this.isClubAdmin()
    const selfSelected = items.some(item => item.id === this.currentMemberId)

    const disableMessageFuncs = {
      noneSelected: (action) => itemsEmpty && `To ${action}, please select at least one member.` ,
      adminsSelected: (action) => adminsSelected && `You cannot ${action} when admins are selected.`,
      adminsSelectedNotAdmin: (action) => notAdmin && adminsSelected && `You cannot ${action} when admins are selected and you are not an admin.`,
      selfSelected: (action) => selfSelected && `You cannot ${action} when you are selected.`
    }

    const shouldDisable = {
      tags: { action: "set member tags", disablers: ["noneSelected"] },
      delete: { action: "delete members", disablers: ["noneSelected", "adminsSelectedNotAdmin"] },
      make_active: { action: "make members active", disablers: ["noneSelected"] },
      make_inactive: { action: "make members inactive", disablers: ["noneSelected", "adminsSelected", "selfSelected"] },
      send_message: { action: "send a message to members", disablers: ["noneSelected"] }
    }

    let disableMessages = {}
    Object.entries(shouldDisable).forEach(([op, info]) => {
      info.disablers.forEach(disabler => {
        const message = disableMessageFuncs[disabler](info.action)
        if (message) {
          disableMessages[op] = message
          return
        }
      })
    })

    this.$("[data-bulk-op]").each((idx, el) => {
      const elem = $(el)
      const op = elem.data("bulk-op")
      const disableMessage = disableMessages[op]

      if (disableMessage) {
        elem.addClass("bulk-op-disabled")
        elem.data("disabled", disableMessage)
      } else {
        elem.removeClass("bulk-op-disabled")
        elem.removeData("disabled")
        elem.removeAttr("data-disabled")
      }
    })

    this.$('.bulk_op').hide();
  },
  showDisabledMessage: function(e) {
    const message = $(e.currentTarget).data('disabled')
    $("#disabled-op-content").html(message)
    $("#disabled-op").modal("show")

    e.preventDefault()
    e.stopImmediatePropagation()
  },
  showBulkOp: function(e) {
    const bulkOp = $(e.currentTarget).attr('data-bulk-op');
    const show = !this.$('.bulk_op_' + bulkOp).is(':visible');
    this.$('.bulk_op').hide();
    if(show)
      this.$('.bulk_op_' + bulkOp).show();
    return false;
  },
  batchDelete: function() {
    const items = this.grid.selectedItems
    if (!items.length) {
      customAlert("No members selected. Click the checkboxes next to the members you'd like to delete first.")
    } else {
      customConfirm(`Are you sure? This will delete ${items.length} selected member${items.length > 1 ? 's' : ''}`, () => this.grid.deleteSelectedItems())
    }
    return false
  },
  batchMakeActive: function() {
    const items = this.grid.selectedItems
    if (!items.length) {
      customAlert("No members selected. Click the checkboxes next to the members you'd like to make active first.");
    } else {
      customConfirm(`Are you sure? This will make ${items.length} selected member${items.length > 1 ? 's' : ''} active`, () => {
        this.grid.setAttributeOnSelectedItems('active', true)
      })
    }
    return false
  },
  batchMakeInactive: function() {
    const items = this.grid.selectedItems
    if (!items.length) {
      customAlert("No members selected. Click the checkboxes next to the members you'd like to make active first.")
    } else {
      customConfirm(`Are you sure? This will make ${items.length} selected member${items.length > 1 ? 's' : ''} inactive`, () => {
        this.grid.setAttributeOnSelectedItems('active', false)
      })
    }
    return false
  },
  batchUpdateTags: function(e) {
    const tagsStr = this.$('input.tag_names').val();
    const isAdd = $(e.currentTarget).hasClass('batch_add_tags');
    const tagAction = isAdd ? 'add' : 'remove';

    if (tagsStr === '') {
      if(isAdd)
        customAlert('When adding tags, press &lt;enter&gt; after you type the tag, then click the Add Tags button.');
      else
        customAlert('When removing tags, press &lt;enter&gt; after you type the tag, then click the Remove Tags button.');
      return;
    }

    this.grid.remoteRequest({
      url: `/clubs/${this.clubId}/batch_update_members_tags.json`,
      params: (selectedIds) => { return { club_member_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr } },
      done: (dataView, data) => {
        dataView.beginUpdate()
        data.forEach((memberData) => {
          var member = dataView.getItemById(memberData.id)
          member.tag_names = memberData.tag_names
          dataView.updateItem(member.id, member)

          if (isAdd) {
            member.tag_names.forEach((tag) => {
              if (!this.tags.includes(tag)) {
                this.tags.push(tag)
                this.$('select.filter_by_tag').append('<option value="'+tag+'">'+tag+'</option>')
              }
            })
          }
        })
        dataView.endUpdate();
        this.$('input.tag_names').select2('val', '');
      }
    })
  },

  initBatchMessageModal: function() {
    const modal = $("#modal_bulk_message")

    modal.on("click", "button.send-bulk-message", () => { this.batchSendMessage() })
    modal.on('hidden.bs.modal', () => {
      modal.find(".errors").hide()
      modal.find(".bulk-message-subject").val("")
      modal.find(".bulk-message-message").val("")
    })
  },

  onBatchMessageClick: function() {
    const items = this.grid.selectedItems
    if (items.length == 0) {
      return
    } else {
      const members_noun = items.length > 1 ? "members" : "member"
      $(".bulk-message-title").html(`Send message to ${items.length} ${members_noun}`)
      $("#modal_bulk_message").modal("show")
    }
    return false
  },

  batchSendMessage: function() {
    const modal = $("#modal_bulk_message")
    const errors = modal.find(".errors")

    const subject = modal.find(".bulk-message-subject").val()
    const message = modal.find(".bulk-message-message").val()

    function showError(message) {
      errors.html(message)
      errors.show()
    }

    if (subject.trim().length === 0 || message.trim().length === 0) {
      showError("You must enter a subject and a message")
      return
    } else {
      errors.hide()
    }

    this.grid.remoteRequest({
      url: `/clubs/${this.clubId}/batch_message_members.json`,
      params: (selectedIds) => { return { club_member_ids: selectedIds.join(','), subject: subject, message: message } },
      done: () => {
        modal.modal("hide")
        $.jGrowl("Your message has been sent")
      },
      fail: (errors) => {
        showError(`Failed to send message: ${errors.join(', ')}`)
      },
      skipFailListeners: true
    })
  },

  /*
   * misc
   */

  cleanMemberData: function(data) {
    return {
      id: data.id,
      user_id: data.user_id,
      first_name: data.first_name || data.user.first_name,
      last_name: data.last_name || data.user.last_name,
      display_name: data.user.display_name,
      email: data.email || data.user.real_email,
      manages_billing: data.manages_billing,
      manages_routes: data.manages_routes,
      manages_members: data.manages_members,
      admin: data.admin,
      active: data.active,
      approved_at: data.approved_at,
      tag_names: data.tag_names || []
    }
  },

  selectTags: function (accumulator, item) {
    return accumulator.concat(item.tag_names || [])
  },

  resizeGrid: function() {
    // Don't resize anything if sizes have been set by the user
    if (this.savedSettings.columnWidths) { return }

    this.grid.slickGrid.resizeCanvas();
    this.grid.slickGrid.autosizeColumns();
  },
  increaseGridHeight: function() {
    this.changeGridHeight(100);
  },
  decreaseGridHeight: function() {
    this.changeGridHeight(-100);
  },
  changeGridHeight(amount) {
    const $table = $('#members_table');
    let height = $table.height();
    if(height + amount < 100) return;
    height += amount;
    $table.height(height).trigger('resize');
    Application.setPreference("members_grid_height", height, true);
  },

  initTagInputBoxes: function() {
    this.$('.tag_select2_input').val('').select2({
      openOnEnter: false,
      width: '150px',
      placeholder: 'Member Tags',
      tokenSeparators: [','],
      tags: this.tags,
      selectOnBlur: true,
      formatNoMatches: function() { return ''; },
      createSearchChoice: (term) => {
        for (var value of this.tags) {
          if (value.toUpperCase() === term.toUpperCase()) {
            return {id: value, text: value};
          }
        }
        return {id: term, text: term}
      }
    });
  }
});



// WEBPACK FOOTER //
// ./public/javascripts/clubs/club_members_view.js